import { configureStore } from '@reduxjs/toolkit';
import translationReducer from '../../../../common/lib/redux/slices/translationSlice';

export const store = configureStore({
  reducer: {
    translations: translationReducer,
  },
});

export type NS1PEState = ReturnType<typeof store.getState>;
export type NS1PEDispatch = typeof store.dispatch;

export default store;
